<script>
import baseMixin from '@mixins/baseMixin'
import TheDebugBar from '@components/dev/the-debug-bar.vue'
import TheNavDrawer from '@components/layout/the-nav-drawer.vue'
import TheTopBar from '@components/layout/the-top-bar.vue'
import TheNotificationPermissionBar from '@components/layout/the-notification-permission-bar.vue'

// TODO: Investigate impact of removing 100px margin-bottom

export default {
  components: {
    TheDebugBar,
    TheNavDrawer,
    TheTopBar,
    TheNotificationPermissionBar,
  },
  mixins: [baseMixin],
  props: {
    noGutters: {
      type: Boolean,
    },
  },
  data() {
    return {
      drawer: null,
    }
  },
  computed: {
    compXAxisPadding() {
      switch (true) {
        case this.isLarge:
        case this.isMedium:
          return 'px-8'
        case this.isSmall:
          return 'px-2'
        default:
          return ''
      }
    },
  },
  mounted() {
    // Init drawer state on mobile to be closed
    this.drawer = !this.isMobileViewPort
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer
    },
  },
}
</script>

<template>
  <v-app id="rr-vue" :class="{ 'embedded-bg': isEmbedded }" :dark="setTheme()">
    <TheDebugBar />
    <TheNavDrawer
      v-if="!isEmbedded"
      :drawer="drawer"
      @setDrawerState="drawer = $event"
    />
    <TheTopBar v-if="!isEmbedded" @toggleDrawer="toggleDrawer" />

    <v-main class="mainDiv">
      <TheNotificationPermissionBar v-if="!isEmbedded" />
      <v-container
        :class="['fill-height', noGutters ? 'ma-0 pa-0' : '', compXAxisPadding]"
        :fluid="isLargeOrLower"
        :style="isSmallOrHigher && !isEmbedded ? 'margin-bottom: 100px' : ''"
      >
        <v-layout justify-center>
          <v-flex xs12 sm12 md12>
            <slot />
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<style>
.embedded-bg {
  background: #eee !important;
}
</style>
